import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=8bee4acc&scoped=true&"
import script from "./CardIcon.vue?vue&type=script&lang=ts&"
export * from "./CardIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CardIcon.vue?vue&type=style&index=0&id=8bee4acc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bee4acc",
  null
  
)

export default component.exports